<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="time" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="mdi-timetable"
        readonly
        v-on="on"
        hint="DD/MM/YYYY format"
      ></v-text-field>
    </template>
    <v-time-picker v-model="time" scrollable format="24hr">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">{{$t("cancel")}}</v-btn>
      <v-btn text color="primary" @click="changeTime(time)">{{$t("confirm")}}</v-btn>
    </v-time-picker>
  </v-dialog>
</template>
<script>
export default {
  props: ["value", "label", "format"],
  data() {
    return {
      time: "",
      modal: false,
      timeFormatted: ""
    };
  },
  methods: {
    changeTime(value) {
      this.$refs.dialog.save(value);
      this.$emit("changeTime", value);
    }
  },
  mounted() {
    this.time = this.value;
  }
};
</script>